module.exports = __webpack_public_path__ + "static/media/hab4-2.9b8d9bde.jpg";